import { Component, Input, EventEmitter, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { AngularCombo } from 'angular_library/models/angular-combo';

@Component({
    moduleId: module.id,
    selector: 'combo-input',
    templateUrl: 'combo-input.html'
})
export class ComboInputComponent   implements OnChanges{ //

    @Input() comboData: AngularCombo = new AngularCombo();
    @Input() ngModelValue: any;    
    @Input() cssClass: string = 'form-control';    
    @Input() placeholder: string;
    @Input() disabled: boolean = false;
    @Input() readOnly: boolean = false;    
    @Input() inputId: string;
    @Output() ngModelValueChange = new EventEmitter();
    innerValue: string;

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && (changes["ngModelValue"])) {
            if (this.ngModelValue != null && this.ngModelValue != undefined) {               
                    this.innerValue = this.ngModelValue;
            }
            else this.innerValue = "";
        }
    }
    onChange(event) {
        if (!event.target) return;
       
        if (!this.comboData || !this.comboData.ListaValori && this.comboData.ListaValori.length > 0) return;    
        this.innerValue = event.target.value;      
        this.ngModelValueChange.emit(event.target.value);               
    }      
    innerValueChange(event) {
        this.ngModelValueChange.emit(event);        
    }
   /*  setValueInput(value) {                       
        if (!this.comboData || !this.comboData.ListaValori && this.comboData.ListaValori.length > 0) return;
        this.comboData.ListaValori.find(x => x.value == value).selected = true;
        for (let i = 0; i < this.comboData.ListaValori.length; i++) 
        {
            if (this.comboData.ListaValori[i].selected ) {
                this.ngModelValue =  this.comboData.ListaValori[i].descrizione;
            }    
        }            
    }    
   public clear() {
        if (!this.comboData || !this.comboData.ListaValori || this.comboData.ListaValori.length == 0) return;
        this.comboData.ListaValori.forEach(element => {
            element.selected = false;
        });        
    }  */       
}


// WEBPACK FOOTER //
// ./src/angular_library/components/combo-input/combo-input.component.ts